import {
  Row,
  Column,
  Form,
  FormGroup,
  PasswordInput,
  Button,
  Loading,
} from '@carbon/react';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Page } from '../../../components/Page';
import { alertActions, userActions } from '../../../redux/actions';
import '../_overrides.scss';

const initialError = {
  error: false,
  error_text: '',
};

export const ChangePassword = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.user);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const [validateState, setValidationState] = useState({
    error: false,
    empty: true,
    oldPassword: {
      ...initialError,
    },
    newPassword: {
      ...initialError,
    },
    newPasswordRepeat: {
      ...initialError,
    },
  });

  const submitPasswordChange = () => {
    if (validateState.error === false && validateState.empty === false) {
      setIsSaving(true);
      dispatch(userActions.changeOwnPassword(oldPassword, newPassword));
    } else {
      dispatch(
        alertActions.error(
          'Die Änderung kann nicht übermittelt werden, bitte prüfe die Eingaben',
          'Kennwort Änderung fehlgeschlagen!'
        )
      );
    }
  };

  useEffect(() => {
    if (loading === false && isSaving === true) {
      setIsSaving(false);
      setOldPassword('');
      setNewPassword('');
      setNewPasswordRepeat('');
    }
  }, [loading, isSaving]);

  const onChangeHandler = (e) => {
    switch (e.currentTarget.id) {
      case 'old_password_input':
        setOldPassword(e.currentTarget.value);
        break;
      case 'new_password_input':
        setNewPassword(e.currentTarget.value);
        break;
      case 'new_password_repeat_input':
        setNewPasswordRepeat(e.currentTarget.value);
        break;
      default:
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let currentState = {
      ...validateState,
    };

    currentState.error = false;
    currentState.empty = true;

    if (newPassword.length > 0) {
      currentState.empty = false;
      if (newPassword.length < 8) {
        currentState.error = true;
        currentState.newPassword.error = true;
        currentState.newPassword.error_text =
          'Das Kennwort muss mindestens 8 Zeichen haben';
      } else {
        if (newPassword.length > 256) {
          currentState.error = true;
          currentState.newPassword.error = true;
          currentState.newPassword.error_text =
            'Das Kennwort darf nicht mehr als 256 Zeichen haben';
        } else {
          currentState.newPassword.error = false;
        }
      }
    }
    if (newPasswordRepeat.length > 0) {
      currentState.empty = false;
      if (newPasswordRepeat !== newPassword) {
        currentState.error = true;
        currentState.newPasswordRepeat.error = true;
        currentState.newPasswordRepeat.error_text =
          'Die Kennwörter müssen identisch sein';
      } else {
        currentState.newPasswordRepeat.error = false;
      }
    }

    setValidationState(currentState);
  }, [newPassword, newPasswordRepeat]);

  return (
    <Page pageTitle="Kennwort ändern" hasSideNav>
      <Row>
        <Column md={4}>
          <div className="label_text">
            Es ist ein sicheres Kennwort erforderlich. Gebe 8–256 Zeichen ein.
            Verwenden keine gängigen Wörter oder Namen. Kombinieren Groß- und
            Kleinbuchstaben, Ziffern und Symbole.
          </div>
        </Column>
      </Row>
      <Row>
        <Column md={3}>
          <Form>
            <FormGroup legendText="">
              <PasswordInput
                autoComplete="off"
                id="old_password_input"
                value={oldPassword}
                onChange={onChangeHandler}
                size="sm"
                labelText="Altes Kennwort"
                invalid={validateState.oldPassword.error}
                invalidText={validateState.oldPassword.error_text}
              />
              <PasswordInput
                autoComplete="off"
                id="new_password_input"
                value={newPassword}
                onChange={onChangeHandler}
                size="sm"
                labelText="Neues Kennwort erstellen"
                invalid={validateState.newPassword.error}
                invalidText={validateState.newPassword.error_text}
              />
              <PasswordInput
                autoComplete="off"
                id="new_password_repeat_input"
                value={newPasswordRepeat}
                onChange={onChangeHandler}
                size="sm"
                labelText="Neues Kennwort bestätigen"
                invalid={validateState.newPasswordRepeat.error}
                invalidText={validateState.newPasswordRepeat.error_text}
              />
            </FormGroup>
          </Form>
          <Button
            disabled={
              validateState.error === true || validateState.empty === true
            }
            onClick={submitPasswordChange}>
            Speichern
          </Button>
          <Loading active={loading} withOverlay={true} />
        </Column>
      </Row>
    </Page>
  );
};
